import { common } from "./common";
import { user } from "./user";
import { Subject } from "rxjs";
import { interact, URLS } from "fire-wind-water";
import { auth } from "./auth";
import { data } from "./data";
import {getOpenId, setChannel, setOpenId} from "./cookie";
import { replaceDomain } from "../help/url";
import $ from "jquery";
class Link {
  instance: any;
  customFormId: any;
  customFormInfo: any;
  jumpUrl: string;
  meetingInfo: any = {};
  memberInfo: any;
  isJump = false;

  init(o) {
    const $s = new Subject<any>();
    const isNotLink = URLS.getURL("isNotLink");
    this.instance = o;
    if (isNotLink == "1") {
      this.instance.skIsNotLink = 1;
    }
    this.jumpUrl = "";

    setTimeout(() => {
      if(o.enableWxFollow == 1){
        this.getQrcode(o,$s);
      }
      else {
        if (this[`identity${o.identity}`]) {
          this.isJump = false;
          this[`identity${o.identity}`]($s);
        }
      }
    });
    return $s;
  }

  async identity1(s) {
    if (
      interact.isWeChat &&
      user.openId &&
      auth.weChatId &&
      auth.weChatId !== "0"
    ) {
      await this.initWechat();
    }
    await this.checkRegistration();
    s.next("link-end");
    s.complete();
  }

  async identity2(s) {
    if (
      interact.isWeChat &&
      user.openId &&
      auth.weChatId &&
      auth.weChatId !== "0"
    ) {
      await this.initWechat();
    }
    if (user.wxInfo.subscribe != 1) {
      await this.showWeChatQrCode();
    }
    await this.checkRegistration();
    s.next("link-end");
    s.complete();
  }

  async identity3(s) {
    if (
      interact.isWeChat &&
      user.openId &&
      auth.weChatId &&
      auth.weChatId !== "0"
    ) {
      await this.initWechat();
    }
    const arr = ["customForm"];
    const type = this.instance.meetingType;
    if (
      type == 2 ||
      type == 3 ||
      arr.indexOf(this.instance.skObjectType) !== -1
    ) {
      await this.checkRegistration();
      if (user.status.signupStatus === "allow" && !user.session) {
        await this.initMemberForm();
      }
    } else {
      if (!user.session) {
        await this.initMemberForm();
      }
    }

    s.next("link-end");
    s.complete();
  }

  async identity4(s) {
    await this.checkRegistration();
    if (user.status.signupStatus === "allow") {
      await this.initMeetingForm();
    }
    s.next("link-end");
    s.complete();
  }

  async showWeChatQrCode() {
    const info = {
      weChatId: auth.weChatId,
      qrType: 2,
      objId: this.instance.skObjectId,
    };
    return new Promise((resolve) => {
      data.weChatQrCode(info).subscribe((res) => {
        if (res) {
          user.wxQrCode.qrCodeUrl = res.qrCodeUrl;
          user.wxQrCode.qrName = res.qrName;
        }
        resolve(res);
      });
    });
  }

  async initMemberForm() {
    const info = {
      tenantId: common.tenantId || "",
      schemaId: common.schemaId,
      formId: this.instance.memberFormId,
      memberFormId: this.instance.memberFormId,
      isLoginLink: 1,
    };
    return new Promise((resolve) => {
      data.getForNewForm(info).subscribe((res) => {
        if (res) {
          this.initMemberUrl(res);
        }
        resolve("member-form");
      });
    });
  }


  qrCodeRender = (res) => {
    const bottomText = interact.isMobile
      ? interact.isWeChat
        ? '长按识别二维码，关注官方公众号'
        : '保存或分享至微信，关注我们'
      : '打开手机微信扫一扫，关注我们';
    const qrCodeHtml = $(
      "<div style='position: fixed;top:0;left: 0;width: 100%;height: 100%;background-color: rgba(0,0,0,.5);z-index:1000; color: #333333; font-size: 16px;'>" +
        "<div style='width: 300px; background-color: white;margin: auto;border-radius: 10px;position: relative;top:50%;transform: translateY(-50%);padding: 30px;box-sizing: border-box;'>" +
        "<p style='text-align: center;margin: 30px 0px;'>您还未关注公众号</p>" +
        "<div style='display: block;width: 200px;height: 200px;margin: 0 auto;border: 1px solid #ccc;position: relative'>" +
        " <div id='qrcode_loading' class='sk-loading-row' style='position: absolute;top: 50%;transform: translateY(-50%);'>" +
        "<div class='sk-loading-spin'>" +
        "<span class='sk-loading-item'></span>" +
        "<span class='sk-loading-item'></span>" +
        "<span class='sk-loading-item'></span>" +
        "<span class='sk-loading-item'></span>" +
        '</div>' +
        '</div>' +
        "<img id='wechat_qrCode' src='' style='display: none;width: 100%;height: 100%;position: absolute;right: 0;bottom:0;' alt=''/>" +
        '</div>' +
        "<p style='text-align: center;margin-top: 10px;'>" +
        res.wechatName +
        '</p>' +
        "<p style='text-align: center;margin-top: 10px;'>" +
        bottomText +
        '</p>' +
        '</div>' +
        '</div>'
    );
    requestAnimationFrame(() => {
      qrCodeHtml.appendTo('body');
      const $qrCode = $('#wechat_qrCode');
      const $loading = $('#qrcode_loading');
      // 图片加载完成后再显示
      $qrCode
        .on('load', () => {
          $qrCode.show();
          $loading.hide();
        })
        .attr('src', res.img);
    });
  };

  getQrcode(o, $s) {
    const param = {
      wechatId: auth.weChatId || o.weChatIdForSubscribe,
      moduleId: common.moduleId,
      instanceId: common.instanceId,
      currentUrl : window.location.href,
      openId:user.openId || getOpenId(o.weChatIdForSubscribe) || '',
      type: common.type,
      objId: common.objId,
      tenantId: common.tenantId,
      sceneId: URLS.getURL("sceneId") || URLS.getHash("sceneId") || '',
    };
    data.getTmpImg(param).subscribe((res) =>{
      if(res){
        if(res.browserInfo && !Array.isArray(res.browserInfo)){
          setChannel(res.browserInfo);//设置渠道
        }
        if (res.isSubscribe === 0) {
          if (window.parent && window.parent !== window) {
            window.parent.postMessage(
              {
                type: 'renderQrCode',
                res: res
              },
              '*'
            );
          } else {
            this.qrCodeRender(res);
          }
          this.checkRegistration().then(() => {
            $s.next('link-end');
            $s.complete();
          });
        } else {
          user.subscribeOpenId = res.openId;
          user.openId = res.openId;
          setOpenId(res.wechatId, res.openId);

          if (this[`identity${o.identity}`]) {
            this.isJump = false;
            this[`identity${o.identity}`]($s);
          }
        }

      }
    })

  }

  initMemberUrl(res) {
    this.memberInfo = res;
    const type = interact.isMobile ? "wap" : "pc";
    const weChatId = URLS.getURL("weChatId");
    let murl = res.originUrl ? res.originUrl[type] : "";
    let turl = window.location.href;
    if (weChatId) {
      murl = URLS.updateSearchParam("weChatId", weChatId, murl);
    }
    if (user.wxInfo.authCode) {
      murl = URLS.updateSearchParam("authCode", user.wxInfo.authCode, murl);
    }

    turl = URLS.removeSearchParam(
      turl,
      "token",
      "retCode",
      "puzzleFlag",
      "excode",
      "scope"
    );
    murl = URLS.updateSearchParam("backUrl", encodeURIComponent(turl), murl);
    // murl += interact.isWeChat ? '#wechat_redirect' : '';
    this.jumpUrl = murl;
    this.isJump = true;
    if (this.instance.skIsNotLink !== 1) {
      window.location.href = replaceDomain(murl);
    }
  }

  async initWechat() {
    await user.getOpenId();
    return new Promise((resolve) => {
      resolve("openId-member");
    });
  }

  async initMeetingForm(): Promise<any> {
    await this.initMeeting();
    await this.initCustomForm();
    this.initCustomFormUrl();
    return new Promise((resolve) => {
      resolve("link-end");
    });
  }

  initCustomFormUrl() {
    const type = interact.isMobile ? "mobile" : "pc";
    const template = this.customFormInfo.template[type];
    const customFormId = this.customFormId;
    const configId = template.configId;
    const url =
      template.formalUrl +
      "?customFormId=" +
      customFormId +
      "&instanceId=" +
      this.instance.meetingInstanceId +
      "&configId=" +
      configId +
      (this.instance.weChatId ? "&wechatId=" + this.instance.weChatId : "") +
      "&returnUrl=" +
      encodeURIComponent(window.location.href) +
      template.formalUrlLocation;
    this.jumpUrl = url;
    this.isJump = true;
    if (this.instance.skIsNotLink !== 1) {
      window.location.href = replaceDomain(url);
    }
  }

  async initCustomForm() {
    const info = {
      tenantId: common.tenantId,
      customFormId: this.customFormId,
      globalUserId: user.globalUserId,
    };
    return new Promise((resolve) => {
      data.getCustomForm(info).subscribe((res) => {
        if (res) {
          this.customFormInfo = res;
        }
        resolve(this.customFormInfo);
      });
    });
  }

  async initMeeting() {
    if (parseInt(this.instance.meetingType, 10) === 3) {
      await this.initSeminar();
    }
    if (parseInt(this.instance.meetingType, 10) === 2) {
      await this.initWebinar();
    }
    return new Promise((resolve) => {
      resolve(this.customFormId);
    });
  }

  async initWebinar(): Promise<any> {
    const info = {
      instanceId: this.instance.meetingInstanceId,
      webinarId: "",
      includeCustomField: false,
      tenantId: common.tenantId,
    };
    return new Promise((resolve) => {
      data.getWebinar(info).subscribe((res) => {
        if (res) {
          this.customFormId = res.customFormId;
          this.meetingInfo = res;
        }
        resolve(this.customFormId);
      });
    });
  }

  async initSeminar(): Promise<any> {
    const info = {
      instanceId: this.instance.meetingInstanceId,
    };
    return new Promise((resolve) => {
      data.getSeminar(info).subscribe((res) => {
        if (res) {
          this.customFormId = res.registerFormId;
          this.meetingInfo = res;
        }
        resolve(this.customFormId);
      });
    });
  }

  // 检查用户状态
  checkRegistration() {
    const info: any = {
      instanceId: this.instance.meetingInstanceId,
      tenantId: common.tenantId,
      globalUserId: user.globalUserId,
      session: user.session || "",
      sess: user.session || "",
      openId: user.openId || user.subscribeOpenId || "",
    };
    const type = {
      poll: "pollId",
      customForm: "customFormId",
      questionary: "questionnaireId",
    };
    info[type[this.instance.skObjectType]] = this.instance.skObjectId;
    if (this.instance.skObjectType === "questionary") {
      info.includeDeFormData = 1;
      info.checkRegisterFormStatus = 1;
    }
    if (!type[this.instance.skObjectType]) {
      return new Promise((resolve) => {
        resolve("userStatus");
      });
    }
    return new Promise((resolve) => {
      data
        .checkRegistration(info, this.instance.skObjectType)
        .subscribe((data) => {
          if (data) {
            user.updateStatus(data, data.formData || []);
          }
          resolve("userStatus");
        });
    });
  }
}

export const link = new Link();
